export const fuseOptions = {
  shouldSort: true,
  includeMatches: true,
  includeScore: true,
  useExtendedSearch: true,
}
